import { FC } from 'react'
import { Alert, Form } from 'react-bootstrap'
import { RecordStatusFieldProps } from '../Forms.d'

const RecordStatusField: FC<RecordStatusFieldProps> = ({
    id,
    name,
    formikProps,
    onLabel,
    offLabel,
}) => {
    const { values, setFieldValue } = formikProps

    return (
        <Alert
            variant={values[name] ? 'success' : 'warning'}
            className="d-block clearfix"
        >
            <Form.Group controlId={id}>
                <Form.Switch
                    type="checkbox"
                    label={values[name] ? onLabel : offLabel}
                    name={name}
                    checked={values[name] || false}
                    className="float-end"
                    onChange={(e) => {
                        setFieldValue(name, e.target.checked)
                    }}
                />
            </Form.Group>
        </Alert>
    )
}

export default RecordStatusField
